import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestPostFirstTimePointerDelete = {
    path: "/post/firstTimePointer",
    method: RouteHttpVerb.DELETE
};
export { locationRestPostFirstTimePointerDelete };
